import { withCompInfo } from '@wix/editor-elements-integrations'
import { minimumLabelFontSize } from '../../core/carmi/InputUtils/constants'
import { FileUploaderDefinition, FileUploaderCSSVars } from './FileUploader'
import { getHeightPixelValue, getScaledFont } from '@wix/thunderbolt-becky-root'
import { getInputHeightInPx, getLabelPaddingObject } from '../../core/mappers/inputUtils'

export const css = withCompInfo<FileUploaderCSSVars, FileUploaderDefinition>()(
	[
		'compData',
		'compProps',
		'compLayout',
		'compSingleLayout',
		'styleProperties',
		'siteFonts',
		'isMobileView',
		'hasResponsiveLayout',
		// @ts-ignore - remove once isOneDocMigrated is added to CompInfo
		'isOneDocMigrated',
	],
	// @ts-ignore - remove once siteFonts is added to the compInfo
	({
		compData,
		compProps,
		compLayout,
		compSingleLayout,
		styleProperties,
		siteFonts,
		isMobileView,
		hasResponsiveLayout,
		// @ts-ignore - remove once isOneDocMigrated is added to CompInfo
		isOneDocMigrated,
	}) => {
		const {
			filesAlignment,
			buttonAlignment,
			showPlaceholder,
			showFileName = true,
			labelMargin,
			inputHeight,
			inputHeightMobile,
		} = compProps
		const { placeholderLabel } = compData
		const hidePlaceholder = !showPlaceholder || !placeholderLabel
		const hideTextBelowButton = !showFileName && hidePlaceholder
		const compInfo = { compLayout, compProps, styleProperties, siteFonts, isMobileView }
		const height = getHeightPixelValue(compLayout, compSingleLayout)

		return {
			'--chooseFileButtonDir': buttonAlignment,
			'--buttonPadding': compData.buttonLabel
				? buttonAlignment === 'ltr'
					? '0 0 0 8px'
					: '0 8px 0 0'
				: '0 0 0 0',
			'--xIconMargin': filesAlignment === 'right' ? '0 0 0 8px' : '0 8px 0 0',
			'--tooltipIconMargin': filesAlignment === 'right' ? '0 8px 0 0' : '0 0 0 8px',
			'--filesDirection': filesAlignment === 'right' ? 'rtl' : 'ltr',
			'--filesAlignment': filesAlignment,
			'--filesJustifyContent': filesAlignment === 'center' ? 'center' : 'flex-start',
			'--filesPlaceholderVisibility': hidePlaceholder ? 'hidden' : 'inherit',
			'--textBelowButtonDisplay': hideTextBelowButton ? 'none' : 'block',
			'--btn_fnt': getScaledFont(compInfo, 'btn_fnt', isOneDocMigrated, compProps.inputMobileFontSize),
			'--file_fnt': getScaledFont(
				compInfo,
				'file_fnt',
				isOneDocMigrated,
				compProps.textBelowButtonMobileFontSize
			),
			'--labelMarginBottom': `${labelMargin}px`,
			'--fntlbl': getScaledFont(
				compInfo,
				'fntlbl',
				isOneDocMigrated,
				compProps.labelMobileFontSize,
				minimumLabelFontSize
			),
			'--requiredIndicationDisplay':
				styleProperties.txtlblrq && styleProperties.txtlblrq !== 'transparent' ? 'inline' : 'none',
			...getLabelPaddingObject(compProps),
			...(!hasResponsiveLayout && {
				height: 'auto',
				'--inputHeight': getInputHeightInPx({
					isMobileView,
					height,
					inputHeight: inputHeight!,
					inputHeightMobile: inputHeightMobile!,
				}),
			}),
		}
	}
)
